import {
  Card,
  Col,
  Row,
  Table,
  Input,
  Spin,
  Pagination,
  message,
  Select
} from "antd";
import { LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import debounce from "lodash.debounce";
import { VIEW_GROUP_SELECTED } from "../../apis/apis";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { useLocation } from "react-router-dom";


function ViewGroup() {

  const location = useLocation();
  const groupNameFromParent = location.state?.groupName;

  const navigate = useNavigate();
  const { id } = useParams();
  const [page_size, set_page_size] = useState(10);


  // const [searchType, setSearchType] = useState("name");
  // const [search_value, set_search_value] = useState("");
  const [search_query_key, set_search_query_key] = useState("name");
  const [search_query_value, set_search_query_value] = useState("");
  const [placeholder, set_placeholder] = useState("Search by name");



  const [loading, setLoading] = useState(true);
  const [pagination_loading, set_pagination_loading] = useState(false);

  const [group_name, set_group_name] = useState("");
  const [table_data, set_table_data] = useState([]);

  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_users, set_total_users] = useState("");
  const [search_name, set_search_name] = useState("");

  // ================= API CALL =================
  const LIST_API = async (page = 1, size = page_size, key = "name", value = "") => {
    try {
      page === 1 ? setLoading(true) : set_pagination_loading(true);

      const FORM_DATA = new FormData();
      FORM_DATA.append("id", atob(id));
      FORM_DATA.append("page", page);
      FORM_DATA.append("page_size", size);


      if (value) {
        FORM_DATA.append(key, value); // 👈 dynamic key
      }

      const response = await VIEW_GROUP_SELECTED(FORM_DATA);

      if (response?.data?.status) {


        // 👇 TABLE DATA
        set_table_data(response?.data?.data?.contacts || []);

        // 👇 PAGINATION DATA (API se directly)
        set_current_page(response?.data?.current_page);
        set_page_size(response?.data?.per_page);
        set_total_pages(response?.data?.total_pages);
        set_total_users(response?.data?.total_contacts);
      } else {
        message.error("Failed to load group data");
      }

    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
      set_pagination_loading(false);
    }
  };

  // ✅ group name parent se set karo
  useEffect(() => {
    if (groupNameFromParent) {
      set_group_name(groupNameFromParent);
    }
  }, [groupNameFromParent]);

  useEffect(() => {
    if (id) {
      LIST_API(1, page_size);
    }
  }, [id]);

  // ================= SEARCH =================
  //   const debouncedSearch = useCallback(
  //     debounce((value, type) => {
  //       set_search_value(value);
  //       LIST_API(1, page_size, type, value);
  //     }, 500),
  //     [page_size]
  //   );

  //  const handleSearch = (e) => {
  //   const value = e.target.value;
  //   set_search_value(value);
  //   if (searchType === "contact_no") {
  //     LIST_API(1, page_size, "contact_no", value);
  //   } else {
  //     debouncedSearch(value, searchType);
  //   }
  // };



  // ================= PAGINATION =================
  const pagination_on_change = (page) => {
    LIST_API(page, page_size, search_query_key, search_query_value);
  };

  const onPageSizeChange = (page, size) => {
    set_page_size(size);
    LIST_API(1, size, search_query_key, search_query_value);
  };


  const fetchResults = useCallback((search_key, search_value) => {
    debounce(async () => {
      try {
        set_pagination_loading(true);

        const FORM_DATA = new FormData();
        FORM_DATA.append("id", atob(id));
        FORM_DATA.append("page", 1);
        FORM_DATA.append("page_size", page_size);

        if (search_value) {
          FORM_DATA.append(search_key, search_value);
        }

        const response = await VIEW_GROUP_SELECTED(FORM_DATA);

        if (response?.data?.status) {
          set_table_data(response?.data?.data?.contacts || []);
          set_current_page(response?.data?.current_page);
          set_total_pages(response?.data?.total_pages);
          set_total_users(response?.data?.total_contacts);
        }
      } catch (err) {
        console.error("Search API Error:", err);
      } finally {
        set_pagination_loading(false);
      }
    }, 500)();
  }, [id, page_size]);

  const selectBefore = (
    <Select
      defaultValue="Name"
      onChange={(value) => {
        if (value === "Name") {
          set_search_query_key("name");
          set_placeholder("Search by name");
          fetchResults("name", search_query_value);
        }

        if (value === "Email") {
          set_search_query_key("email");
          set_placeholder("Search by email");
          fetchResults("email", search_query_value);
        }

        if (value === "Phone") {
          set_search_query_key("contact_no");
          set_placeholder("Search by phone");
          fetchResults("contact_no", search_query_value);
        }
      }}
    >
      <Select.Option value="Name">Name</Select.Option>
      <Select.Option value="Email">Email</Select.Option>
      <Select.Option value="Phone">Phone</Select.Option>
    </Select>
  );
  const handleInput = (e) => {
    const value = e.target.value;
    set_search_query_value(value);

    if (search_query_key === "name") {
      fetchResults("name", value);
    }

    if (search_query_key === "email") {
      fetchResults("email", value);
    }

    if (search_query_key === "contact_no") {
      fetchResults("contact_no", value);
    }
  };



  // ================= TABLE COLUMNS =================
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => <span>{record.name}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (_, record) => <span>{record.email}</span>,
    },
    {
      title: "Phone",
      dataIndex: "contact_no",
      key: "contact_no",
      render: (_, record) => <span>{record.contact_no || "N/A"} </span>,
    },
  ];

  return (
    <div className="lms-body">
      <Card>
        {loading ? (
          <CulsightPageLoader />
        ) : (
          <>
            {/* Header */}
            <Row style={{ marginBottom: "15px" }}>
              <Col span={24}>
                <h2 style={{ cursor: "pointer", marginBottom: "20px" }}
                  onClick={() => navigate("/user-group")}>
                  <LeftOutlined />{group_name}</h2>
                <p>
                  <strong>Total Users:</strong> {total_users}
                </p>
              </Col>
            </Row>

            {/* Search */}
            <Row style={{ marginBottom: "15px" }}>

              <Col span={12}>
                <Input
                  addonBefore={selectBefore}
                  placeholder={placeholder}
                  onChange={handleInput}
                  size="large"
                  value={search_query_value}
                />
              </Col>

            </Row>


            {/* Table */}
            {pagination_loading ? (
              <div style={{ textAlign: "center", padding: "50px" }}>
                <Spin indicator={<LoadingOutlined spin />} size="large" />
              </div>
            ) : (
              <Table
                columns={columns}
                dataSource={table_data}
                pagination={false}
                rowKey={(record, index) => record?.id || index}
                locale={{ emptyText: "No users found" }}
              />
            )}

            {/* Pagination */}
            {total_pages > 0 && (
              <div style={{ float: "right", marginTop: "20px" }}>
                <Pagination
                  current={current_page}
                  total={total_users}
                  pageSize={page_size}
                  showSizeChanger
                  pageSizeOptions={['10', '20', '50', '100']}
                  onChange={pagination_on_change}
                  onShowSizeChange={onPageSizeChange}
                />

              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
}

export default ViewGroup;
